import { Button, Group } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import cx from 'clsx';

import classes from './StepperCard.module.css';
import type { SlideOption } from '#plugin-chat/components/tools/ask-user-question/schema.ts';

export interface ConfirmationSlideProps {
  options: SlideOption[];
  kind?: 'default' | 'danger' | 'info' | 'warning';
  onOptionClick: (id: string) => void;
  isStreaming?: boolean;
}

/** Yes/No confirmation slide with styled confirm/cancel buttons. */
export function ConfirmationSlide({ options, onOptionClick, isStreaming: _isStreaming }: ConfirmationSlideProps) {
  // Convention: first option is confirm (positive), second is cancel (negative)
  if (!options || options.length < 2) {
    return null;
  }

  const [confirmOption, cancelOption] = options;

  return (
    <Group className={classes.confirmationButtons} gap="sm">
      {cancelOption && (
        <Button
          className={cx(classes.confirmButton, classes.cancel)}
          color="gray"
          leftSection={<IconX size={16} />}
          onClick={() => onOptionClick(cancelOption.id)}
          variant="subtle"
        >
          {cancelOption.label}
        </Button>
      )}
      {confirmOption && (
        <Button
          className={cx(classes.confirmButton, classes.confirm)}
          // TODO: make color configurable
          // color="green"
          // TODO: make icon/kind configurable - could also provide color
          leftSection={<IconCheck size={16} />}
          onClick={() => onOptionClick(confirmOption.id)}
          variant="filled"
        >
          {confirmOption.label}
        </Button>
      )}
    </Group>
  );
}
